import { render, staticRenderFns } from "./user-reset-password.component.vue?vue&type=template&id=6c1e99fc&scoped=true&"
import script from "./user-reset-password.component.ts?vue&type=script&lang=ts&"
export * from "./user-reset-password.component.ts?vue&type=script&lang=ts&"
import style0 from "./user-reset-password.component.scss?vue&type=style&index=0&id=6c1e99fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1e99fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VForm})
